import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_PAGINATED_BATCHES = 'GET_PAGINATED_BATCHES';

// async actions
export const GETTING_PAGINATED_BATCHES = 'GETTING_PAGINATED_BATCHES';
export const GETTING_PAGINATED_BATCHES_SUCCEEDED =
  'GETTING_PAGINATED_BATCHES_SUCCEEDED';
export const GETTING_PAGINATED_BATCHES_FAILED =
  'GETTING_PAGINATED_BATCHES_FAILED';

export const GET_ATTACHMENT_FILE = 'GET_ATTACHMENT_FILE';
export const CLEAR_BATCH_STORE = 'CLEAR_BATCH_STORE';

export const UPDATE_BATCH_FILTERS = 'UPDATE_BATCH_FILTERS';
export const RESET_BATCH_FILTERS = 'RESET_BATCH_FILTERS';

export const getPaginatedBatches = createAction(GET_PAGINATED_BATCHES);

export const gettingPaginatedBatches = createAction(GETTING_PAGINATED_BATCHES);
export const gettingPaginatedBatchesSucceeded = createAction(
  GETTING_PAGINATED_BATCHES_SUCCEEDED
);
export const gettingPaginatedBatchesFailed = createAction(
  GETTING_PAGINATED_BATCHES_FAILED
);

export const getAttachmentFile = createAction(GET_ATTACHMENT_FILE);
export const clearBatchStore = createAction(CLEAR_BATCH_STORE);

export const updateBatchFilters = createAction(UPDATE_BATCH_FILTERS);
export const resetBatchFilters = createAction(RESET_BATCH_FILTERS);